import { render, staticRenderFns } from "./UserPropertyData.vue?vue&type=template&id=95708b2a"
import script from "./UserPropertyData.vue?vue&type=script&lang=js"
export * from "./UserPropertyData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports